import * as actionTypes from 'src/app/state/actions/types';
import type { Dispatch, RootState } from 'src/app/state/store';

export function updateMedicationForm(medicationFormIndex, medicationForm) {
  return {
    type: actionTypes.UPDATE_MEDICATION_SHOW_CONTROLLED_FORM,
    medicationFormIndex,
    medicationForm,
  };
}

export function fetchAllMedicationForms(medications) {
  return {
    type: actionTypes.FETCH_ALL_MEDICATION_FORMS,
    medications,
  };
}

export function fetchMedicationFormByIndex(medicationForm) {
  return {
    type: actionTypes.FETCH_MEDICATION_FORM_BY_INDEX,
    medicationForm,
  };
}

export function getMedicationFormByIndex(medicationFormIndex) {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const state = getState();
    const { medicationForms } = state;
    const { medications } = medicationForms;
    if (medicationFormIndex in medications) {
      return dispatch(fetchMedicationFormByIndex(medications[medicationFormIndex]));
    }
  };
}
